export default __webpack_public_path__ + "static/media/Sheriff_White.916c2cf9.png";